import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="Remonter en haut de page"
      onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }}
      className={`fixed bottom-5 right-5 z-[60] flex h-12 w-12 items-center justify-center rounded-full bg-emerald-600 text-white shadow-[0_18px_40px_rgba(5,150,105,0.28)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-emerald-700 sm:bottom-6 sm:right-6 ${visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
      data-testid="scroll-to-top-button"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}